import Callout from '../../callout/Callout';
import PropTypes from 'prop-types';
import React from 'react';
import SwiperButton from '../../swiperButton/SwiperButton';
import { generateRoutePath } from '@epic-core/common';

const NewMapsBlock = ({block, handlePrev, handleNext, active}) => {
    const { bgImage, headline, buttonText } = block;

    return (
        <div className="home--new-maps-block home-section-block" style={{backgroundImage: `url('${bgImage}')`}}>
            <SwiperButton onClick={handlePrev} inverted />
            <div className="home-section-block-content">
                <Callout
                    headline={headline}
                    buttonText={buttonText}
                    buttonLink={generateRoutePath('maps')}
                    align="center"
                    active={active}
                />
            </div>
            <SwiperButton onClick={handleNext} />
        </div>
    )
};

NewMapsBlock.propTypes = {
    block: PropTypes.object,
    handlePrev: PropTypes.func,
    handleNext: PropTypes.func,
    active: PropTypes.bool
};

NewMapsBlock.defaultProps = {
    block: {},
    handlePrev: fn => fn,
    handleNext: fn => fn,
    active: false
};

export default NewMapsBlock;
